import * as React from 'react';
import { useCallback } from 'react';
import { Checkbox, ICheckboxStyles } from '@fluentui/react/lib/Checkbox';
import { gridSubUnit } from '@uifabric/portal-ux/lib/styling/stylingConstants';

export interface IContactPreferenceCheckboxProps {
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const ContactPreferenceCheckbox = ({
  label,
  disabled,
  checked,
  onChange
}: IContactPreferenceCheckboxProps): React.ReactElement | null => {
  const handleChange = useCallback(
    (_: any, newValue = false) => {
      onChange?.(newValue);
    },
    [onChange]
  );

  return <Checkbox styles={styles} label={label} disabled={disabled} checked={checked} onChange={handleChange} />;
};

const styles: ICheckboxStyles = {
  root: ['ContactPreferenceCheckbox', { margin: `${gridSubUnit * 5}px 0` }]
};
